<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.32195 5.30168C5.71247 4.91116 6.34564 4.91116 6.73616 5.30168L18.7362 17.3017C19.1267 17.6922 19.1267 18.3254 18.7362 18.7159C18.3456 19.1064 17.7125 19.1064 17.3219 18.7159L5.32195 6.7159C4.93142 6.32537 4.93142 5.69221 5.32195 5.30168Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.7362 5.30168C19.1267 5.69221 19.1267 6.32537 18.7362 6.7159L6.73616 18.7159C6.34564 19.1064 5.71247 19.1064 5.32195 18.7159C4.93142 18.3254 4.93142 17.6922 5.32195 17.3017L17.3219 5.30168C17.7125 4.91116 18.3456 4.91116 18.7362 5.30168Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
